import { useState, useMemo } from 'react';
import { useAuth } from '../security/AuthContext';
import { getCurrentUser, updateAvatar, updateUser } from '../services/AuthService';
import { useNotification } from '../components/Notifications';
import { Avatar } from '../components/Avatar';


export default function ProfilePage() {
  const { user, login } = useAuth();
  const { addNotification } = useNotification();
  const [isEditingBio, setIsEditingBio] = useState(false);
  const [avatarFile, setAvatarFile] = useState(user.avatarFile);
  const [tempBio, setTempBio] = useState(user.bio);
  const firstLetter = user?.lastName?.charAt(0).toUpperCase() || 'U';


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        setAvatarFile((await updateAvatar(file)).Id);
        user.avatarFile = avatarFile;
        addNotification('Avatar updated', 'success');
      } catch (err) {
        addNotification('Failed to save avatar ' + err.message, 'error');
      }
    }
  };

  const saveBio = async () => {
    try {
      let u = await getCurrentUser();
      u.bio = tempBio;
      login(await updateUser(u));
      addNotification('Bio updated', 'success');  
      setIsEditingBio(false);
    } catch (err) {
      addNotification('Failed to save bio ' + err.message, 'error');
    }
  };

  const avatarUrl = () => {
    return `/api/users/avatar/${user.id}?token=` + localStorage.getItem('token');
  };

  return (
    <div className="bg-gray-100 bg-opacity-30 flex items-center justify-center py-8">
      <div className="bg-white rounded-lg shadow-xl max-w-xl w-full p-8 mx-4">
        <div className="flex flex-col items-center">
          <div className="relative mb-6">
            <Avatar user={user} big={true} />
            <label className="absolute bottom-0 right-0 bg-indigo-500 text-white rounded-full w-8 h-8 flex items-center justify-center cursor-pointer hover:bg-indigo-600">
              <i className="fas fa-pencil text-sm"></i>
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="hidden"
              />
            </label>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">
            {user.firstName} {user.lastName}
          </h2>
          <p className="text-gray-600 mb-6 text-center">
            {user.email || 'No Email'}
          </p>
          <div className="w-full mb-6 flex items-center justify-center">
            {isEditingBio ? (
              <div className="flex w-full max-w-md items-center">
                <input
                  type="text"
                  value={tempBio}
                  onChange={(e) => setTempBio(e.target.value)}
                  className="flex-grow px-3 py-1.5 border border-gray-300 rounded-md text-gray-600 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 whitespace-normal break-words"
                  placeholder="About you"
                />
                <button
                  onClick={saveBio}
                  className="ml-1 bg-indigo-500 text-white rounded-full w-8 h-8 flex items-center justify-center cursor-pointer hover:bg-indigo-600"
                >
                  <i className="fas fa-check text-sm"></i>
                </button>
                <button
                  onClick={() => {
                    setIsEditingBio(false);
                    setTempBio(user.bio);
                  }}
                  className="ml-1 bg-indigo-500 text-white rounded-full w-8 h-8 flex items-center justify-center cursor-pointer hover:bg-indigo-600"
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>
            ) : (
              <div className="flex w-full max-w-md items-center justify-center">
                <p
                  className={`flex-grow text-gray-600 text-center whitespace-normal break-words ${(user.bio ? user.bio.length : 0) >= 20 ? 'max-w-[20ch]' : ''
                    }`}
                >
                  {user.bio || 'About you'}
                </p>
                <button
                  onClick={() => setIsEditingBio(true)}
                  className="bg-indigo-500 text-white rounded-full w-8 h-8 flex items-center justify-center cursor-pointer hover:bg-indigo-600"
                >
                  <i className="fas fa-pencil text-sm"></i>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}